import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { clearAlerts, setErrorAlert } from "../../../store/alert/alertSlice";
import { add_personal_user_userInfo_thunk } from "../../../store/auth/authThunk";
import { LoginFun } from "../../../store/auth/authSlice";
import TypeWriter from "../../../components/OnBoard/Typewriter";
import dizeeLogo from "../../../assets/images/dizee logo.svg";
import styled from "styled-components";
import AccessibilityWidget from "../../../components/AccessibilityWidget";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 350px;
  margin: 0 auto;
  padding-left: 35px;
  padding-top: 0;
  overflow: hidden;
  height: 100vh;
  position: relative;
  touch-action: none;
`;

const FormSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 80px;
  gap: 2px;
  margin-top: -40px;
  height: 100%;
  position: relative;
  padding-top: 40px;
`;

const ButtonContainer = styled.div`
  height: 40px;
  margin-top: 40px;
  display: flex;
  align-items: center;
  position: relative;
`;

const ActionButton = styled.div`
  font-size: 12px;
  color: ${props => props.disabled ? 'rgba(255, 255, 255, 0.3)' : 'white'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  height: 18px;
  line-height: 18px;
  position: relative;
`;

const Footer = styled.div`
  position: fixed;
  bottom: 27px;
  width: 280px;
`;

const LogoImage = styled.img`
  width: 48px;
  height: auto;
  margin-bottom: 16px;
`;

const FooterText = styled.div`
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  max-width: 280px;
  line-height: 1.5;
`;

const Step12 = ({ setStep, setUser, user }) => {
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);
  const persistedData = localStorage.getItem("persist:root");
  const dispatch = useDispatch();

  useEffect(() => {
    if (user?.avatar) {
      if (typeof user.avatar === "string") {
        setPreview(user.avatar);
      } else if (user.avatar instanceof Blob) {
        setPreview(URL.createObjectURL(user.avatar));
      }
    }
  }, [user?.avatar]);

  useEffect(() => {
    // More comprehensive scroll prevention
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.height = '100%';
    document.body.style.touchAction = 'none'; // Prevent touch scrolling

    return () => {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = 'unset';
      document.body.style.position = 'static';
      document.body.style.width = 'auto';
      document.body.style.height = 'auto';
      document.body.style.touchAction = 'auto';
    };
  }, []);

  const changeAvatar = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setPreview(URL.createObjectURL(selectedFile));
      setUser({ ...user, avatar: selectedFile });
    }
  };

  const handleSubmit = async () => {
    // e.preventDefault(); // Prevent default form submission
    dispatch(clearAlerts());

    try {
    const url = new URL(window.location.href);
    const emailParam = url.searchParams.get("email");
      const userParamString = url.searchParams.get("user");
      
      let userParam = null;
      if (userParamString) {
        try {
          userParam = JSON.parse(userParamString);
        } catch (e) {
          console.error("Failed to parse user parameter:", e);
        }
      }

      // Create a copy of user object to avoid mutation
      const userToSubmit = {
        ...user,
        email: userParam ? userParam.email : emailParam
      };

      // Add some validation for required fields
      if (!userToSubmit.email) {
        dispatch(setErrorAlert("Email is required"));
        return;
      }

      // Ensure we have basic required fields
      if (!userToSubmit.professionRole) {
        dispatch(setErrorAlert("Profession role is required"));
        return;
      }

      // Log the data being sent for debugging
      console.log("Submitting user data:", userToSubmit);

             dispatch(add_personal_user_userInfo_thunk(userToSubmit)).then((res) => {
         console.log("API response:", res);
        if (res?.payload?.status === 200) {
           // Set user as logged in
           dispatch(LoginFun(true));
           
           // Complete onboarding and redirect to main app instead of continuing to presentation
           if (userToSubmit?.professionRole === 'artist') {
             window.location.href = "/";
           } else if (['manager', 'agent', 'label', 'publisher', 'business-manager'].includes(userToSubmit?.professionRole)) {
             window.location.href = "/team-member-dashboard";
           } else {
             window.location.href = "/more";
           }
         } else {
           // Handle API errors more gracefully
           const errorMsg = res?.payload?.message || res?.error?.message || 'Failed to save user information';
           dispatch(setErrorAlert(errorMsg));
         }
       }).catch((error) => {
         console.error("API call failed:", error);
         dispatch(setErrorAlert("Failed to save user information. Please try again."));
       });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      dispatch(setErrorAlert("An error occurred while processing your information"));
    }
  };

  const handleNext = async () => {
    if (user.professionRole === "artist" || user.professionRole === "manager") {
      // For artists and managers, complete the onboarding here instead of going to step 13
      handleSubmit();
    } else {
      handleSubmit(); // Ensure handleSubmit is called correctly
    }
  };

  // Handle key press events
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleNext(); // Call your next step function
    }
  };

  return (
    <Container>
      <FormSection>
        <div className="w-[200px]">
          <div
            className="mb-[68px] cursor-pointer"
            onClick={() => document.getElementById("avatar").click()}
          >
            <TypeWriter
              key={preview ? "change" : "upload"}
              text={preview ? "Change cover image" : "Upload a cover image"}
              speed={45}
            />
          </div>

          <input
            type="file"
            className="hidden"
            id="avatar"
            onChange={changeAvatar}
          />

          {preview && (
            <div className="profile-picture mb-9 min-h-[100px]">
              <div className="avatar">
                <img
                  src={preview}
                  className="h-[80px] w-[80px]"
                  alt="avatar"
                  style={{
                    objectFit: 'cover',
                    borderRadius: '4px'
                  }}
                />
              </div>
            </div>
          )}

          <ButtonContainer>
            <ActionButton
              disabled={!(file || user?.avatar)}
              onClick={() => {
                if (file || user?.avatar) {
                  handleNext();
                }
              }}
              className="mr-[43px]"
            >
              Next
            </ActionButton>

            <ActionButton
              onClick={() => {
                setStep(22);
              }}
            >
              Go back
            </ActionButton>
          </ButtonContainer>
        </div>
      </FormSection>

      <Footer>
        <LogoImage src={dizeeLogo} alt="DIZEE" />
        <FooterText>
          Upload a profile picture that represents you or your brand. This will be displayed on your profile page.
        </FooterText>
      </Footer>
      <AccessibilityWidget />
    </Container>
  );
};

export default Step12;
